import styled from 'styled-components'

export const HelpText = styled.p`
  font-size: 14px;
  line-height: 100%;
  color: rgba(107, 124, 147, 0.54);;
`
export const RadioText = styled.div`
  font-size: 16px;
  line-height: 24 px;
  color: #6B7C93;
  width: 100px;
`



// WEBPACK FOOTER //
// ./src/components/SignUpForm/styles.js